import * as React from 'react';
import { format } from 'date-fns';
import { Prompt } from 'react-router';
import { reduxForm } from 'redux-form';
import { Card } from 'material-ui/Card';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import { compose, withProps } from 'recompose';
import Button from '@inqool/uas-web-core/es/components/controls/Button';

import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import { getReport } from '@modules/reports/_reportsActions';
import * as T from '@modules/reports/_reportsTypes';
import { ReportsFormBasic } from '@modules/reports/ReportsFormBasic';

export const enhance = compose<T.ReportsFormProps, T.Outter>(
  entityDetailEnhancer<T.ReportsEnhancerProps<T.Report>, T.Report>({
    getEntity: getReport,
    defaultEntity: {}
  }),
  breadcrumbs(({ entity }) => [
    { label: 'Reporty', to: '/reports' },
    { label: entity && entity.id ? 'Nový záznam' : 'Upravit záznam' }
  ]),
  withProps<{}, T.ReportsProps>(({ entity }) => ({
    initialValues: {
      ...entity,
      active: true
    },
    maxYear: format(new Date(), 'YYYY')
  })),
  reduxForm({
    form: 'module-Reports'
  })
);

export const View: React.SFC<T.Outter & T.ReportsFormProps> = ({ handleSubmit, closeItem, ...props }) => (
  <div>
    <Prompt
      when={props.dirty && !props.submitSucceeded && !props.submitting}
      message="Vaše změny nebyly uloženy, přesto odejít?"
    />
    <form className="layout" onSubmit={handleSubmit}>
      <Card>
        <ReportsFormBasic />
        <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
        <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
      </Card>
    </form>
  </div>
);

export const ReportsForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/reports/ReportsForm.tsx